import React, { useState, useEffect } from 'react';
import {
  FaLock, FaLockOpen, FaExchangeAlt, FaRedo, FaUserPlus,
  FaFont, FaMicrophone, FaSpinner
} from 'react-icons/fa';
import { adminUserService } from '../../../services/adminUserService';
import { formatdateWithTime } from '../../../utils/helpers';

const ACTION_CONFIG = {
  block:           { label: 'Bloquear',        icon: <FaLock />,         bg: 'rgba(239,68,68,0.12)',    color: '#F87171' },
  unblock:         { label: 'Desbloquear',      icon: <FaLockOpen />,     bg: 'rgba(34,197,94,0.12)',    color: '#4ADE80' },
  change_plan:     { label: 'Cambio de plan',   icon: <FaExchangeAlt />,  bg: 'rgba(59,130,246,0.12)',   color: '#60A5FA' },
  set_text_limit:  { label: 'Límite texto',     icon: <FaFont />,         bg: 'rgba(168,85,247,0.12)',   color: '#C084FC' },
  set_voice_limit: { label: 'Límite voz',       icon: <FaMicrophone />,   bg: 'rgba(99,102,241,0.12)',   color: '#818CF8' },
  reset_usage:     { label: 'Resetear uso',     icon: <FaRedo />,         bg: 'rgba(245,158,11,0.12)',   color: '#FBBF24' },
  create_user:     { label: 'Crear usuario',    icon: <FaUserPlus />,     bg: 'rgba(255,255,255,0.08)',  color: '#9BA3B8' },
};

const ActionDetail = ({ action, details }) => {
  if (!details) return null;

  if (action === 'change_plan') {
    return (
      <span className="text-xs" style={{ color: '#9BA3B8' }}>
        Plan: <span className="font-medium">{details.before?.plan_id || '—'}</span>
        {' → '}
        <span className="font-medium">{details.after?.plan_id || '—'}</span>
      </span>
    );
  }

  if (action === 'set_text_limit') {
    const before = details.before?.custom_text_limit;
    const after = details.after?.custom_text_limit;
    return (
      <span className="text-xs" style={{ color: '#9BA3B8' }}>
        Texto: <span className="font-medium">{before ?? 'plan'}</span> → <span className="font-medium">{after ?? 'plan'}</span>
      </span>
    );
  }

  if (action === 'set_voice_limit') {
    const before = details.before?.custom_voice_limit;
    const after = details.after?.custom_voice_limit;
    return (
      <span className="text-xs" style={{ color: '#9BA3B8' }}>
        Voz: <span className="font-medium">{before ?? 'plan'}</span> → <span className="font-medium">{after ?? 'plan'}</span>
      </span>
    );
  }

  if (action === 'block') {
    return (
      <span className="text-xs" style={{ color: '#9BA3B8' }}>
        Razón: {details.after?.block_reason || '—'}
      </span>
    );
  }

  if (action === 'reset_usage') {
    return <span className="text-xs" style={{ color: '#9BA3B8' }}>Fecha: {details.date}</span>;
  }

  if (action === 'create_user') {
    return (
      <span className="text-xs" style={{ color: '#9BA3B8' }}>
        {details.email} | Rol: {details.role} | Plan: {details.plan_id || '—'}
      </span>
    );
  }

  return null;
};

const HistorialAcciones = ({ userId }) => {
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    adminUserService.getAdminLog(userId)
      .then(setLog)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) {
    return (
      <div className="flex justify-center py-8" style={{ color: '#6B7391' }}>
        <FaSpinner className="animate-spin" size={24} />
      </div>
    );
  }

  if (log.length === 0) {
    return <p className="text-sm text-center py-8" style={{ color: '#6B7391' }}>Sin historial de acciones</p>;
  }

  return (
    <div className="space-y-3">
      {log.map(entry => {
        const cfg = ACTION_CONFIG[entry.action] || { label: entry.action, icon: null, bg: 'rgba(255,255,255,0.08)', color: '#9BA3B8' };
        const cfgStyle = { backgroundColor: cfg.bg, color: cfg.color };
        return (
          <div key={entry.id} className="flex items-start gap-3 p-3 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm" style={cfgStyle}>
              {cfg.icon}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={cfgStyle}>
                  {cfg.label}
                </span>
                <span className="text-xs whitespace-nowrap" style={{ color: '#6B7391' }}>
                  {formatdateWithTime(entry.created_at)}
                </span>
              </div>
              <p className="text-xs mt-1" style={{ color: '#9BA3B8' }}>Por: <span className="font-medium" style={{ color: '#C8CDD9' }}>{entry.admin_nombre}</span></p>
              <div className="mt-1">
                <ActionDetail action={entry.action} details={entry.details} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HistorialAcciones;
